import React from 'react';
import { reduxForm, Field } from 'redux-form';

import FormError from 'components/FormError';
import InputField from 'components/InputField';
import CheckboxField from 'components/CheckboxField';

import styles from './styles.module.scss';
import { isBlank } from 'helpers/validators';

let MassDataBlockForm = ({ handleSubmit, error, carrier }) => {
  return (
    <form className={styles.form} onSubmit={handleSubmit}>
      <div className={styles.inputs}>
        <Field
          component={InputField}
          name="subscription_ids"
          label="Subscription IDs*"
          subText="Comma separated list. Ex.: 101,201"
        />
      </div>
      <Field
        component={CheckboxField}
        name="validate_overdue"
        label="Validate overdue"
      />

      {error && <FormError error={error} />}
      <button className="btn btn-primary">Mass Data Block</button>
    </form>
  );
};

const validate = (values) => {
  let errors = {};

  if (isBlank(values.subscription_ids)) {
    errors.subscription_ids = 'Required';
  }

  return errors;
};

MassDataBlockForm = reduxForm({
  form: 'massDataBlockForm',
  validate,
})(MassDataBlockForm);

export default MassDataBlockForm;
